<template>
  <div class="flex align-center">
    <div v-if="startLabel" class="mr-10">{{ startLabel }}</div>
    <div>
      <div v-if="formType === 'select'">
        <el-select
          v-model="value.start"
          v-bind="getProps(startFormProps, formType, 'start')"
        >
          <el-option
            v-for="(item, index) in startOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="formType === 'input'">
        <el-input
          v-model="value.start"
          v-bind="getProps(startFormProps, formType, 'start')"
        />
      </div>
      <div v-if="formType === 'input-number'">
        <el-input-number
          v-model="value.start"
          v-bind="getProps(startFormProps, formType, 'start')"
          @change="inputNumberStartChange"
        />
      </div>
    </div>
    <div v-if="startUnit" class="ml-5">{{ startUnit }}</div>
    <div class="ml-10 mr-10">-</div>
    <div v-if="endLabel" class="mr-10">{{ endLabel }}</div>
    <div>
      <div v-if="formType === 'select'">
        <el-select
          v-model="value.end"
          v-bind="getProps(endFormProps, formType, 'end')"
        >
          <el-option
            v-for="(item, index) in endOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div v-if="formType === 'input'">
        <el-input
          v-model="value.end"
          v-bind="getProps(endFormProps, formType, 'end')"
        />
      </div>
      <div v-if="formType === 'input-number'">
        <el-input-number
          v-model="value.end"
          v-bind="getProps(endFormProps, formType, 'end')"
        />
      </div>
    </div>
    <div v-if="endUnit" class="ml-5">{{ endUnit }}</div>
  </div>
</template>

<script>
export default {
  name: 'FormRange',
  model: {
    prop: 'value',
  },
  props: {
    /** 双向绑定值 */
    value: {
      type: Object,
      default: () => {
        return {
          start: null,
          end: null,
        };
      },
    },
    /** 表单类型 - 支持select、input和input-number */
    formType: {
      type: String,
      default: 'select',
    },
    /** 起始选项 - formType = select时必填 */
    startOptions: {
      type: Array,
      default: () => [],
    },
    /** 结束选项 - formType = select时必填 */
    endOptions: {
      type: Array,
      default: () => [],
    },
    /** 起始和结束共用表单属性 - 对应表单类型 */
    formProps: {
      type: Object,
      default: () => {},
    },
    /** 起始表单属性 - 对应表单类型 */
    startFormProps: {
      type: Object,
      default: () => {},
    },
    /** 结束表单属性 - 对应表单类型 */
    endFormProps: {
      type: Object,
      default: () => {},
    },
    /** 起始标签值 */
    startLabel: {
      type: String,
      default: '',
    },
    /** 结束标签值 */
    endLabel: {
      type: String,
      default: '',
    },
    /** 起始单位 */
    startUnit: {
      type: String,
      default: '',
    },
    /** 结束单位 */
    endUnit: {
      type: String,
      default: '',
    },
    /** 是否具有范围关联 - 不允许end小于start，目前仅支持input-number */
    isAssociated: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /**
     * 获取表单属性
     * @param {Object} props 表单属性
     * @param {string} type 表单类型
     * @param {string} status 起始或结束
     */
    getProps(props, type, status) {
      // 支持的表单类型
      const type_map = {
        'select': {
          placeholder: '请选择',
          clearable: true,
          size: 'mini',
        },
        'input': {
          placeholder: '请输入',
          clearable: true,
          size: 'mini',
        },
        'input-number': {
          placeholder: '请输入',
          clearable: true,
          size: 'mini',
        },
      };

      const result = Object.assign(type_map[type], { ...this.formProps, ...props });

      // 范围关联
      if (this.isAssociated) {
        if (type === 'input-number' && status === 'end') {
          Object.assign(result, { min: this.value.start });
        }
      }

      return result;
    },
    /**
     * 数值输入框起始change事件
     * @param {number} val 输入值
     */
    inputNumberStartChange(val) {
      if (!this.isAssociated) {
        return;
      }
      val > this.value.end && (this.value.end = val);
    },
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}
.align-center {
  align-items: center;
}
.ml-5 {
  margin-left: 5px;
}
.ml-10 {
  margin-left: 10px;
}
.mr-10 {
  margin-right: 10px;
}
</style>
